// extracted by mini-css-extract-plugin
export default {"container":"WrappingTwoColumnLayout-module__container--Db7v9","left":"WrappingTwoColumnLayout-module__left--sNpWW","right":"WrappingTwoColumnLayout-module__right--c3nNI"};